<template>
    <div>
        <my-header
            isBack
        />

        <div class="search">
            <search-bar
                :keyword="history"
                @search="search"
                isCancel
            />
        </div>

        <div class="history">
            <div class="title flex bottom-20">
                <div class="title-content subtitle">历史搜索</div>
                <van-icon name="delete-o" class="del-icon" @click="onDel"/>
            </div>
            <div class="content">
                <div
                    class="item"
                    v-for="item in historyList"
                    :key="item"
                    @click="onHistoryItem(item)"
                >{{item}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MyHeader from '@/components/myHeader'
import SearchBar from '@/components/searchBar'
import { ref } from '@vue/reactivity'
import {getHistory,dropHistory,saveHistory} from "@/views/search/SearchHistory";

export default {
    name: 'Search',
    components: {
        MyHeader,
        SearchBar
    },
    setup() {
        // init data
        const historyList = ref(getHistory())
        const history = ref('')

        return {
            historyList,
            history
        }
    },

    methods: {
        search(value) {
            this.saveHistory(value)

            const params = {
                path: '/search/result',
                query: {
                    keyword: value
                }
            }

            this.$router.replace(params)
        },

        onDel() {// 清空历史记录
            dropHistory()
            this.historyList = []
        },

        onHistoryItem(item) {
            this.history = item
            this.search(item)
        },

        saveHistory(value) {
            this.historyList = saveHistory(value)
        }
    }
}
</script>

<style scoped>
.history {
    padding: 5vw;
    position: relative;
}

.del-icon {
    position: absolute;
    right: 5vw;
    font-size: 18px;
    color: #808080;
}

.item {
    display: inline-block;
    margin: 5px 0;
    margin-right: 5px;
    padding: 5px 10px;
    background: #DCDCDC;
    border-radius: 32px;
    color: #4E4E4E;
    font-size: 14px;
}
</style>

